import React from 'react'
import { ITable } from '../../interfaces'
import { Button } from "@mui/material";
import FormFields from './FormFields';
import { context } from '../..';


interface ITableProps {
    table: ITable;
    onSubmit: Function
}


const generateRandomId = (length = 6) => {
    return Math.random().toString(36).substring(2, length + 2)
}


export default function TableOpen ({
    table,
    onSubmit = (values) => {}
}: ITableProps) {

    const initialRowsDict = {}
    if (Array.isArray(context.answers[table.list_name]) && context.answers[table.list_name]?.length) {
        context.answers[table.list_name].forEach((row) => {
            var rowKey = generateRandomId()
            initialRowsDict[rowKey] = row
        })
    } else if (context.preloadedAnswers && Array.isArray(context.preloadedAnswers[table.list_name]) && context.preloadedAnswers[table.list_name]?.length) {
        context.preloadedAnswers[table.list_name].forEach((row) => {
            var rowKey = generateRandomId()
            initialRowsDict[rowKey] = row
        })
    } else if (table.min_rows > 0) {
        for (var i = 0; i < table.min_rows; i+=1) {
            var rowKey = generateRandomId()
            initialRowsDict[rowKey] = {}
        }
    }

    const [submitCount, setSubmitCount] = React.useState(0)
    const [error, setError] = React.useState(null)
    const [rowsDict, setRowsDict] = React.useState(initialRowsDict)

    const handleSubmit = () => {
        setSubmitCount(submitCount + 1)

        if (table.min_rows && Object.keys(rowsDict)?.length < table.min_rows) {
            return setError(`You must provide at least ${table.min_rows} entr${table.min_rows > 1 ? "ies" : "y"}`)
        }
        if (table.max_rows && Object.keys(rowsDict)?.length > table.max_rows) {
            return setError(`You must provide no more than ${table.max_rows} entr${table.max_rows > 1 ? "ies" : "y"}`)
        }
        if (error) {
            return
        }

        onSubmit({[table.list_name]: Object.values(rowsDict)})
    }

    return (
        <div className="form-fields">
            {Object.keys(rowsDict).map((rowKey, i) => (
                <div key={rowKey} style={{borderLeft: "5px solid #cbcbcb", paddingLeft: "10px"}}>
                    <div style={{maxWidth: "360px", display: "flex", gap: "15px", justifyContent: "space-between"}}>
                        <h4 style={{marginBottom: "10px", textTransform: "capitalize"}}>
                            {table.list_item_label} ({i+1})
                        </h4>
                    </div>

                    <FormFields
                        key={rowKey}
                        initialValues={rowsDict[rowKey]}
                        fields={table.fields}
                        submitCount={submitCount}
                        submitButtonText=""
                        onChange={(rowFormik) => {
                            var newRowsDict = {...rowsDict, [rowKey]: rowFormik.values}
                            setRowsDict(newRowsDict)
                            setError(Object.keys(rowFormik.errors).length ? "Some fields have failed validation" : null)
                            context.unsubmittedValues = {[table.list_name]: Object.values(newRowsDict)}
                        }} />

                    <div style={{display: "flex", gap: "15px", margin: "15px 0 40px 0"}}>
                        <Button
                            type="submit"
                            color="info"
                            variant="contained"
                            className="btn btn-sm"
                            onClick={() => {
                                setError(null)
                                var newRowsDict = {...rowsDict}
                                delete newRowsDict[rowKey]
                                setRowsDict(newRowsDict)
                            }}>
                            Remove this {table.list_item_label}
                        </Button>                        

                        <Button
                            color="info"
                            variant="contained"
                            className="btn btn-sm"
                            onClick={() => {
                                var newRowKey = generateRandomId()
                                var newRowsDict = {}

                                Object.keys(rowsDict).forEach((rk, o) => {
                                    newRowsDict[rk] = rowsDict[rk]
                                    if (i === o) {
                                        newRowsDict[newRowKey] = {}
                                    }
                                })
                                
                                setRowsDict(newRowsDict)
                            }}>
                            Add new {table.list_item_label}
                        </Button>
                    </div>
                </div>
            ))}

            {!Object.keys(rowsDict).length ? (
                <p>Start by adding a {table.list_item_label}{table.min_rows ? <span>, you must enter at least {table.min_rows}.</span> : <span>, this is optional.</span>}</p>
            ) : null}

            <div style={{display: "flex", gap: "15px"}}>
                {/* <Button
                    color="info"
                    variant="contained"
                    className="btn btn-lg"
                    onClick={() => context.saveAndQuit()}>
                    Save and Quit
                </Button> */}

                <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    className="btn btn-lg"
                    disabled={!!submitCount && !!error}
                    onClick={() => handleSubmit()}>
                    Save and Continue
                </Button>
            </div>

            {!!submitCount && !!error ? (
                <div className="warning" style={{marginTop: "15px"}}>{error}</div>
            ) : null}
        </div>
    )
}